/* eslint-disable react/jsx-props-no-spreading */
import { useState } from "react";
import { FieldValues, FormState, UseFormRegister } from "react-hook-form";
import { ReactComponent as EyeOpen } from "../../../assests/icons/eyeOpen.svg";
import { ReactComponent as EyeClose } from "../../../assests/icons/eyeClose.svg";

type FormInputPropType = {
  label: string;
  subLabel?: string;
  bottomLabel?: string;
  type: "text" | "tel" | "password" | "email" | "number" | "url" | "date";
  register: UseFormRegister<FieldValues>;
  name: string;
  placeholder?: string;
  formState: FormState<FieldValues>;
  rules: any;
  disabled?: boolean;
  defaultValue?: string;
};

const FormInput = ({
  label,
  subLabel, // optional
  bottomLabel, // optional
  type,
  register,
  name,
  placeholder, // optional
  formState,
  rules,
  disabled,
  defaultValue,
}: FormInputPropType) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="mt-8">
      <label className="text-[15px] md:text-[17px] font-medium" htmlFor={name}>
        {label}
      </label>
      {subLabel && <p className="text-[#B8B8B8] text-xs">{subLabel}</p>}
      <div className="relative">
        <input
          className="h-12 w-full rounded-[4px] text-[15px] md:text-base border border-gray-400 outline-none py-1 mt-2 pr-[40px] pl-5"
          type={type === "password" && showPassword ? "text" : type}
          max={new Date().toISOString().split("T")[0]}
          placeholder={placeholder}
          disabled={disabled}
          defaultValue={defaultValue}
          {...register(name, rules)}
        />
        {type === "password" && showPassword && (
          <div
            className="absolute right-6 bottom-2 cursor-pointer"
            onClick={() => setShowPassword(false)}
          >
            <EyeOpen />
          </div>
        )}
        {type === "password" && !showPassword && (
          <div
            className="absolute right-6 bottom-2 cursor-pointer"
            onClick={() => setShowPassword(true)}
          >
            <EyeClose />
          </div>
        )}
      </div>
      {bottomLabel && <p>{bottomLabel}</p>}
      {formState.errors[name] && (
        <p className="text-red-500">
          {formState.errors[name]?.message?.toString()}
        </p>
      )}
    </div>
  );
};

export default FormInput;
